module.exports = __webpack_public_path__ + "static/media/banner.3224de20.png";